var exports = {
  "x6": "TextareaButton.module__button___ZWdYSl",
  "DY": "TextareaButton.module__contextMenuHover___ZWdYSl",
  "wH": "TextareaButton.module__selected___ZWdYSl",
  "Kk": "TextareaButton.module__icon___ZWdYSl",
  "w": "TextareaButton.module__buttonCompact___ZWdYSl" + " " + "TextareaButton.module__button___ZWdYSl",
};

module.exports = exports;
